import { Pipe, PipeTransform } from '@angular/core';

const CYCLE_COLOR_COUNT = 21;

/**
 * Returns the CSS class name for a given cycle index.
 * Can also be called directly from TypeScript when a pipe is not suitable.
 */
export function getCycleColorClass(index: number): string {
  return `cycle-color-${index % CYCLE_COLOR_COUNT}`;
}

/**
 * Maps a cycle index to a cycle-color-N CSS class.
 * The class sets --cycle-main and --cycle-light CSS custom properties
 * which components use for borders, progress bar fills, and legend swatches.
 *
 * Usage: [ngClass]="cycleIndex | cycleColor"
 */
@Pipe({ name: 'cycleColor', standalone: false })
export class CycleColorPipe implements PipeTransform {
  transform(index: number): string {
    return getCycleColorClass(index);
  }
}
